module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA2.2fed2694.jpg";